import MedicalCertificate from "@/views/medical_certificates/medical_certificate.vue";
import MedicalCertificates from "@/views/medical_certificates/index.vue";

export default [
  {
    path: "atestados",
    name: "Atestados",
    component: MedicalCertificates,
  },
  {
    path: "atestados/:medical_certificate_id",
    name: "Editar atestado",
    component: MedicalCertificate,
  },
  {
    path: "atestados/novo",
    name: "Novo atestado",
    component: MedicalCertificate,
  },
];
